/**
 * iter86.77.13 — "Mark tournament complete" card, extracted from
 * ScheduleTab so formats WITHOUT a Schedule tab (golf, NFL season,
 * API-football seasons) can also close a tournament. Rendered in:
 *   - Tournament Settings tab (all formats)
 *   - Schedule tab (custom/legacy templates, where admins already look)
 */
import { Flag } from "lucide-react";

export default function TournamentLockCard({ isLocked, coAdminCtx, onOpenComplete }) {
    if (isLocked) return null;
    // iter87.199.196 — Danger Zone action, always primary-admin-only
    // (matches the backend's unconditional lock in admin_actions.py).
    // No permission key — a co-admin can never be granted this.
    if (coAdminCtx?.role === "co_admin") return null;
    return (
        <div
            className="brutal-card p-5 space-y-3 border-blaze"
            data-testid="tournament-lock-card"
        >
            <div className="flex items-center justify-between gap-2 flex-wrap">
                <div className="flex items-center gap-2">
                    <Flag className="w-5 h-5 text-blaze" />
                    <h2 className="font-display font-extrabold text-xl uppercase">Mark tournament complete</h2>
                </div>
                <button
                    data-testid="open-mark-complete-dialog-btn"
                    onClick={onOpenComplete}
                    className="brutal-btn text-xs py-2 bg-blaze text-white border-black shadow-brutal"
                >
                    <Flag className="w-3.5 h-3.5" /> Mark complete (lock)
                </button>
            </div>
            <p className="text-xs text-zinc-400 leading-relaxed">
                Lock when the result is final. Scores, picks, drafts and scoring rules become read-only. <span className="text-blaze font-bold">Only a site admin can unlock afterwards.</span>
            </p>
        </div>
    );
}
